export default __webpack_public_path__ + "locales/si/DowngradePlanDialog.json?hash=de3b3bc80629d898dd1e5adc55f2c583";